<template>

    <div class="videoPlayer">
        <div class="videoPlayer_content">
            <video width="720" height="405" controls  :poster="getPosterPath(thumb)" ref="video">
                <source :src="getVideoPath(src)" type="video/mp4" />
            </video>
            <transition name="fade">
                <img src="../assets/img/VideoPlayerIcon.png" alt="" class="videoPlayer_btn" v-if="!isPlaying" @click="play" />
            </transition>
        </div>
    </div>

</template>

<script>
    import {SoundManager} from "../utils/SoundManager";

    export default {
        name: 'VideoPlayer',
        data: function(){
            return {
                isPlaying: false
            }
        },
        props: ['src', 'thumb'],
        methods: {
            getPosterPath: function(imgPath){
                return require('../assets/img/'+imgPath);
            },
            getVideoPath: function(videoPath){
                return require('../assets/video/'+videoPath);
            },
            play: function(){
                this.$refs.video.play();
            }
        },
        mounted: function(){
            const vid = this.$refs.video;

            vid.addEventListener("play", () => {
                SoundManager.instance.muted = true;
                this.isPlaying = true;
            });
            vid.addEventListener("pause", () => {
                SoundManager.instance.muted = false;
                this.isPlaying = false;
            });
            vid.addEventListener("ended", () => {
                SoundManager.instance.muted = false;
                this.isPlaying = false;
            });

        },
    };
</script>

<style scoped lang="scss">

    .fade-enter-active {
        transition: all .3s ease;
    }
    .fade-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .videoPlayer{
        &_content{
            position: relative;
        }
        video{
            width: 100%;
            height: auto;
        }

        &_btn{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;
            width: 100px;
            height: auto;
        }
    }
</style>